import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { SetImage } from "@/components/ui/SetImage";
import { SetRow } from "@/hooks/useProducts";
import { useTranslation } from "react-i18next";
import { Sparkles } from "lucide-react";

interface FeaturedCarouselCardProps {
  set: SetRow;
}

export const FeaturedCarouselCard = ({ set }: FeaturedCarouselCardProps) => {
  const { t } = useTranslation();

  return (
    <Link
      to="/catalogo"
      className="group block relative bg-card border border-border/70 hover:border-primary/50 rounded-2xl overflow-hidden shadow-card hover:shadow-card-hover transition-all duration-300 hover:-translate-y-1 h-full select-none"
    >
      <div className="relative aspect-square bg-white overflow-hidden p-4 flex items-center justify-center">
        <SetImage
          src={set.set_image_url || "/placeholder.svg"}
          alt={set.set_name}
          className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute top-3 left-3 flex flex-wrap gap-1">
          <Badge variant="secondary" className="text-[10px] uppercase font-bold tracking-wider bg-background/90 backdrop-blur-sm shadow-sm border border-border/50">
            {set.set_theme}
          </Badge>
        </div>
        <div className="absolute top-3 right-3">
          <span className="inline-flex items-center gap-1 text-[10px] font-semibold text-emerald-700 bg-emerald-50 dark:bg-emerald-950/80 dark:text-emerald-300 px-2 py-0.5 rounded-full border border-emerald-200 dark:border-emerald-800 shadow-sm">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
            Disponible
          </span>
        </div>
      </div>

      <div className="p-4 flex flex-col justify-between space-y-3 bg-card">
        <div>
          <h3 className="font-display font-bold text-sm text-foreground line-clamp-2 min-h-[2.5rem] group-hover:text-primary transition-colors">
            {set.set_name}
          </h3>
          {set.set_ref && (
            <div className="text-[11px] font-mono text-muted-foreground mt-0.5">
              REF: {set.set_ref}
            </div>
          )}
        </div>

        <div className="flex items-center justify-between text-xs text-muted-foreground border-t border-border/40 pt-2.5">
          <span className="font-medium text-[11px]">{set.set_age_range}</span>
          <span className="font-medium text-[11px] flex items-center gap-1">
            <Sparkles className="w-3 h-3 text-amber-500" />
            {set.set_piece_count} {t("product.pieces", "piezas")}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default FeaturedCarouselCard;
